// styles for fast compile
import '../../styles/App.less';
import './configure';

import React, { Component } from 'react';
import { HashRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import ruRu from 'antd/lib/locale-provider/ru_RU';
import enEn from 'antd/lib/locale-provider/en_US';
import { withTranslation } from 'react-i18next';

import Layout from './layout';
import closeRecordConfirmation from '../common/Modal/closeRecordConfirmation';
import closeCatalogEditConfirmation from '../common/Modal/closeCatalogEditConfirmation';

import '../../configs/i18n';
import ErrorBoundary from './providers/ErrorBoundary';
import { backUrlService } from '../../services/backUrl';

const locales = {
  ru: ruRu,
  en: enEn,
};

backUrlService.save();

class App extends Component {
  render() {
    const { language } = this.props.i18n;
    return (
      <ConfigProvider locale={locales[language]}>
        <HashRouter
          getUserConfirmation={(message, callback) => {
            const messageParts = message.split(":");
            const messageType = messageParts[0];
            const messageData = messageParts[1];

            switch (messageType) {
              case 'record':
                closeRecordConfirmation({ message: messageData, callback, t: this.props.t })
                break;
              case 'catalogEdit':
                closeCatalogEditConfirmation({ message: messageData, callback, t: this.props.t })
                break;
            }
          }}
        >
          <ErrorBoundary>
            <Layout />
          </ErrorBoundary>
        </HashRouter>
      </ConfigProvider>
    );
  }
}

export default withTranslation()(App);
